import React from 'react';
import { Container, Card, CardBody, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";

const RightInformation = () => {
    const data = [
       { district: 'Head Quarter Office',  profile: 'Head Office', officer: 'Sh. Yogesh Kumar (Under Secretary Sainik and Ardh Sainik Welfare Department)' },
        { district: '  Ambala',  profile: 'dswAmbala', officer: 'Col Ajay Kumar Sheoran' },
        { district: '  Bhiwani',  profile: '', officer: 'Wg Cdr Sunil Kumar' },
        { district: '  Charkhi Dadri',  profile: 'dswCharkhiDadri', officer: 'Wg Cdr Sunil Kumar' },
        { district: '  Faridabad',  profile: 'dswFaridabad', officer: 'Capt (IN) R S Chhawari' },
        { district: '  Fatehabad',  profile: 'dswFatehabad', officer: 'Wg Cdr Sujata' },
        { district: '  Gurugram',  profile: 'dswGurugram', officer: 'Col Davinder Singh Dhaka' },
        { district: '  Hisar',  profile: '', officer: 'Wg Cdr Sujata' },
        { district: '  Jhajjar',  profile: '', officer: 'Col Kundu' },
        { district: '  Jind',  profile: 'dswJind', officer: 'Wg Cdr Gaurika Suhag' },
        { district: '  Kaithal',  profile: 'dswKaithal', officer: 'Col Ajay Kumar Sheoran' },
        { district: '  Karnal',  profile: 'dswKarnal', officer: 'Wg Cdr Sanjay Kumar Rai' },
        { district: '  Kurukshetra',  profile: '', officer: 'Col Ajay Kumar Sheoran' },
        { district: '  Narnaul',  profile: '', officer: 'Wg Cdr Satish Yadav' },
        { district: '  Nuh',  profile: '', officer: 'Col Davinder Singh Dhaka' },
        { district: '  Palwal',  profile: 'dswPalwal', officer: 'Col Davinder Sing Dhaka' },
        { district: '  Panchkula',  profile: 'dswPanchkula', officer: 'Wg Cdr Sanjay Kumar Rai' },
        { district: '  Panipat',  profile: 'dswPanipat', officer: 'Col Kundu' },
        { district: '  Rewari',  profile: '', officer: 'Capt (IN) R S Chhawari' },
        { district: '  Rohtak',  profile: 'dswRohtak', officer: 'Wg Cdr Gaurika Suhag' },
        { district: '  Sirsa',  profile: '', officer: 'Gp Capt Sudhir Nasiar' },
        { district: '  Sonipat',  profile: 'dswSonepat', officer: 'Capt (IN) R S Chhawari' },
        { district: '  Yamuna Nagar',  profile: 'dswYamunaNagar', officer: 'Wg Cdr Sanjay Kumar Rai' },
       
      ];
    return (
      <>
        <div style={{
          backgroundImage: `url(${footerBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '30px 0',
          color: 'white',
          margin: '2%',
          borderRadius: '10px'
        }}>
          <Container>
            <h3 className="fw-bold mb-0 text-center">
              <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
              Right to Information
            </h3>
          </Container>
        </div>

        <Container className="py-5">
          <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
            <div style={{
              background: 'linear-gradient(135deg, #1c499e 0%, #2a5298 100%)',
              padding: '25px',
              color: 'white'
            }}>
              <h4 className="fw-bold mb-0">
                <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                SPIO (State Public Information Officers)
              </h4>
            </div>
            <CardBody className="p-4">
              <div className="table-responsive">
                <Table bordered hover className="mb-0">
                  <thead>
                    <tr>
                      <th style={{ background: '#1e3c72', color: 'white', width: '8%' }}>Sr. No.</th>
                      <th style={{ background: '#1e3c72', color: 'white', width: '25%' }}>District</th>
                      <th style={{ background: '#1e3c72', color: 'white', width: '25%' }}>Officer Name</th>
                      <th style={{ background: '#1e3c72', color: 'white', width: '42%' }}>First Appellate Authority</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={index}>
                        <td style={{ color: '#495057' }}>{index + 1}</td>
                        <td style={{ color: '#1e3c72', fontWeight: '600' }}>{item.district}</td>
                        <td style={{ color: '#495057' }}>{item.officer}</td>
                        {index === 0 && (
                          <td rowSpan={data.length} style={{ textAlign: 'center', verticalAlign: 'top', color: '#495057' }}>
                            Director General <br/>(Sainik and Ardh Sainik <br/>Welfare Department,<br/> Haryana, Plot No. 100,<br/> Sector-12 Panchkula,<br/> Haryana)
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>

          <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
            <div style={{
              background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
              padding: '25px',
              color: 'white'
            }}>
              <h4 className="fw-bold mb-0">
                <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
                State Information Commission, Haryana
              </h4>
            </div>
            <CardBody className="p-4">
              <div className="table-responsive">
                <Table bordered hover className="mb-0">
                  <thead>
                    <tr>
                      <th style={{ background: '#16a085', color: 'white', width: '8%' }}>Sr. No.</th>
                      <th style={{ background: '#16a085', color: 'white', width: '72%' }}>Address</th>
                      <th style={{ background: '#16a085', color: 'white', width: '20%' }}>Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ color: '#495057' }}>1</td>
                      <td style={{ color: '#495057' }}>STATE INFORMATION COMMISSION, HARYANA,<br/> Netaji Subhas chandra Bose Suchana Bhawan, IP-8,Sector-3 Panchkula, Haryana-134112</td>
                      <td style={{ color: '#495057' }}>
                        <a 
                          href="https://cicharyana.gov.in/" 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{
                            color: '#16a085',
                            textDecoration: 'none',
                            fontSize: '14px',
                            fontWeight: '600',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '5px'
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.color = '#1e3c72';
                            e.currentTarget.style.transform = 'scale(1.05)';
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.color = '#16a085';
                            e.currentTarget.style.transform = 'scale(1)';
                          }}
                        >
                          <FontAwesomeIcon icon={faExternalLinkAlt} />
                          cicharyana.gov.in
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Container>
      </>
    );
};

export default RightInformation;
